module.exports = __webpack_public_path__ + "static/img/4.abe8858.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/zh/4.png
// module id = XkNg
// module chunks = 0